export { default } from './email-collect';
